import { render, staticRenderFns } from "./min_fuel.vue?vue&type=template&id=0883f73a&"
import script from "./min_fuel.vue?vue&type=script&lang=js&"
export * from "./min_fuel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports